﻿import React from 'react';

import SortableCard from '../../components/Common/SortableCard';
import { SortableCardData } from '../../models/Common/sortable-card-data';

import ScrollView from 'devextreme-react/scroll-view';
import Sortable from 'devextreme-react/sortable';

export interface Props {
    id: string;
    title: string;
    height?: string;
    data: SortableCardData[];
    useCheckBox: boolean;
    showIndex?: boolean;
    onCardDrop?: (e: any) => void;
    onCardReorder?: (e: any) => void;
    onValueChanged?: (updatedData: SortableCardData[]) => void;
}

export default function SortableList(props: Props) {

    return (
        <div className="sortable-list" id={props.id}>
            {/* style={{ height: props.height ? props.height : "100%" }} */}
            <div className="sortable-list-title">{props.title}</div>

            <ScrollView className="scrollable-list"
                direction="vertical"
                showScrollbar="always">

                <Sortable id={`list${props.id}`}
                    className="sortable-list-cards"
                    group="cardsGroup"
                    data={props.data}
                    onReorder={onCardReorder}
                    onAdd={onCardDrop}>
                    {props.data && props.data.map((d, idx) => <SortableCard
                        index={idx} showIndex={props.showIndex }
                        useCheckBox={props.useCheckBox} onValueChanged={onValueChanged}
                        key={`card${d && d.id ? d.id : '0'}`}
                        cardData={d} />)}
                </Sortable>

            </ScrollView>
        </div>
    );

    function onValueChanged(e: any) {
        console.log("onValueChanged (LIST LEVEL)");
        console.log(e);

        let updatedData = [...props.data];

        let editedItem = updatedData.find(d => d.id === e.id);

        if (editedItem) {
            editedItem.isChecked = e.isChecked;

            if (props.onValueChanged)
                props.onValueChanged(updatedData);
        }
    }

    function onCardDrop(e: any) {
        console.log("onCardDrop");
        console.log(e);

        if (props.onCardDrop)
            props.onCardDrop(e);
    }


    function onCardReorder(e: any) {
        console.log("onCardReorder");
        console.log(e);

        if (props.onCardReorder)
            props.onCardReorder(e);
    }


}
